import { render, staticRenderFns } from "./tpl-12.vue?vue&type=template&id=5506332a&scoped=true&"
import script from "./tpl-12.vue?vue&type=script&lang=js&"
export * from "./tpl-12.vue?vue&type=script&lang=js&"
import style0 from "./tpl-12.vue?vue&type=style&index=0&id=5506332a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5506332a",
  null
  
)

export default component.exports